import getFieldValue from "./getFieldValue";
import _ from "lodash";

export default function buildTableData(data,fields = null) {
  const fieldsByKey = fields ? _.keyBy(fields, 'field') : null;
  const results = [];

  data.forEach((doc) => {
    const resultObj = {}; // Objeto que armazena as chaves e valores

    for (const key in doc) {

      resultObj[key] = getFieldValue(doc[key]);

      if (fieldsByKey && fieldsByKey[key]) {
        const field = fieldsByKey[key];
        if (field.fieldtype === 'refLookup') {
          const value = doc?.[key]?.[0]?._id;
          if (value !== undefined) {
            resultObj[`${field.field} (ID)`] = value;
          }
        }
      }
    }
    results.push(resultObj);
  });
  return results;
}
